// extracted by mini-css-extract-plugin
export default {"calendarWrapper":"styles_calendarWrapper__KdMp+","noDevice":"styles_noDevice__Ugz8O","loading":"styles_loading__Va0Sb"};